import * as Type from './types'

export function populate(data, mode = Type.POPULATE_CONNECTED, type = Type.POPULATE_AZURE, callback = {success: null, error: null}) {
    return {
        type: type,
        mode: mode,
        data: data,
        callback: callback
    }
}

export function setFormat(data, format = Type.SET_FORMAT, mode = Type.SET_FORMAT_LIST, callback = null)
{
    return {
        type: format,
        mode: mode,
        data: data,
        callback: callback
    }
}

export function setLoaded(provider = 'azure', mode = 'connected', value = true, callback = null) {
    return {
        type: Type.SET_LOADED,
        provider: provider,
        mode: mode,
        data: value,
        callback: callback
    }
}